import React from 'react';
import { sceneImages } from '../../data/images';
import { useShopNavigation } from '../../hooks/useShopNavigation';
import { buttonClasses } from '../../utils/buttonStyles';
export function ClosingCta() {
  const shop = useShopNavigation();
  return <section aria-labelledby="closing-title" className="relative overflow-hidden" data-id="element-110" data-mp="e2h9p86vw4g8">
      <img src={sceneImages.waterTexture} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-111" data-mp="j23kzc35jame" />
      <div className="absolute inset-0 bg-deep/75" aria-hidden data-id="element-112" data-mp="452v7e4itpqk" />
      <div className="relative mx-auto max-w-site px-5 py-28 text-center md:px-8 md:py-36" data-id="element-113" data-mp="96jtd1vmey3g">
        <p className="font-display text-lg uppercase tracking-[0.2em] text-ice" data-id="element-114" data-mp="3rbvj50nybjpm">Anything. Anytime. Anywhere.</p>
        <h2 id="closing-title" className="mx-auto mt-4 max-w-4xl font-display text-5xl font-semibold uppercase leading-[0.92] md:text-7xl" data-id="element-115" data-mp="5lo6g9g4kja">
          One set installed. One set ready.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg text-titanium" data-id="element-116" data-mp="1uhs8q5o8cdo9">
          MarineForceLED — professional-grade lighting. Built for the elements.
        </p>
        <button type="button" onClick={() => shop()} className={`${buttonClasses('primary', 'lg')} mt-10 w-full sm:w-auto`} data-id="element-117" data-mp="1lfe3au1k5wlz">
          Choose your system
        </button>
      </div>
    </section>;
}